import { AnketaAnswerForm } from './AnketaAnswerForm';

export default AnketaAnswerForm;